import React from "react";
import {
    Button, Dialog, DialogActions, DialogContent, DialogTitle
} from "@mui/material";
import { UserPasswordModel } from "../typings";
import UserPasswordDisplay from "./UserPasswordDisplay";

interface PasswordDialogProps {
    userPwdData: UserPasswordModel | null,
    allowEmailUser: boolean,
    handleClose: () => void,
    handleEmailNewUser: () => void
}

const UserPasswordDialog: React.FC<PasswordDialogProps> = ({ userPwdData: userPasswordData, allowEmailUser, handleClose, handleEmailNewUser }: PasswordDialogProps) => {
    return (
        <Dialog
            open={userPasswordData !== null}
            onClose={handleClose}
        >
            <DialogTitle id="alert-dialog-title" variant="h3">
                Attention
            </DialogTitle>
            <DialogContent>
                <UserPasswordDisplay userName={userPasswordData?.userName ?? ""} password={userPasswordData?.password ?? ""} />
            </DialogContent>
            <DialogActions>
                {allowEmailUser &&
                    <Button onClick={handleEmailNewUser} color="primary" variant="contained">Email User</Button>
                }
                <Button onClick={handleClose} color="primary" variant="contained">Done</Button>
            </DialogActions>
        </Dialog>
    );
}

export default UserPasswordDialog;
